import { SUPPORTED_LANGUAGES } from 'lib/constants.mjs';
import styles from './I18n-badge.module.scss';
import { useLocale } from 'next-intl';
import { useTranslations } from 'next-intl';

interface IProps {
	enableDarkMode?: boolean;
	languages?: Array<{
		language: string;
	}>;
	text?: string;
}

const I8nBadge = (props: IProps) => {
	const {
		languages = [{ language: 'en' }],
		text,
		enableDarkMode = false,
	} = props;

	// Corrects for a quirk in how translations are implemented. For a document with no non-English translations
	// the metadata document does not exist and the query for it will produce an empty array. The default
	// case is English only.
	const availableLanguages = languages?.length
		? languages
		: [{ language: 'en' }];

	const localLanguagesUnfiltered = availableLanguages
		.map((language) => {
			return SUPPORTED_LANGUAGES.find(
				(supportedLanguage) => supportedLanguage.id == language?.language,
			)?.localName;
		})
		.filter((x) => !!x); // strip out any languages not found
	const localLanguages = [...new Set(localLanguagesUnfiltered)];
	const languageString = localLanguages.join(', ');

	const t = useTranslations('audio');
	const currentLang = useLocale() || 'en'; // mostly for storybook because it doesn't have a NextJS language context
	const availableInText = text ? text : t('onlyAvailableIn');
	const badgeClassName = enableDarkMode
		? `${styles.playlistSlideTranslations} ${styles.plalistSlideTranslationsDarkMode}`
		: styles.playlistSlideTranslations;

	const showBadge = !availableLanguages.find(
		(language) => language?.language == currentLang,
	);

	if (showBadge) {
		return (
			<div className={styles.container}>
				<div className={badgeClassName}>
					{`${availableInText} ${languageString}`}
				</div>
			</div>
		);
	}
};

export default I8nBadge;
